import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import PropTypes from "prop-types"
import React from "react"

class BoatUS extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      boatUSError: "",
    }
    this.validator = new ReactValidator()
    this.setName = this.setName.bind(this)
    this.setZip = this.setZip.bind(this)
    this.setID = this.setID.bind(this)
    this.callNext = this.callNext.bind(this)
    this.checkBoatUS = this.checkBoatUS.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("BoatUS Membership")
  }

  setName(event) {
    this.props.setGlobalState({ boatUSLastName: event.target.value })
  }

  setZip(event) {
    this.props.setGlobalState({ boatUSZipCode: event.target.value })
  }

  setID(event) {
    this.props.setGlobalState({ boatUSMemberID: event.target.value })
  }

  callNext() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      this.setState({ boatUSError: "" })
      this.checkBoatUS()
    }
  }

  checkBoatUS() {
    const params = {
      boatus_id: this.props.state.boatUSMemberID,
      boatus_zip: this.props.state.boatUSZipCode,
      boatus_last_name: this.props.state.boatUSLastName,
    }

    $.post(
      process.env.API_BASE_URL + "/api/1.0/validate/boatus",
      params,
      (data) => {
        this.props.routeTo("next")
      }
    ).fail((data) => {
      this.setState({
        boatUSError: data.responseJSON.error,
        processing: false,
      })
    })
  }

  render() {
    return (
      <div id="boatUSMembership">
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            autoFocus
            className="form-control"
            id="lastName"
            value={this.props.state.boatUSLastName}
            onChange={this.setName}
          />
          {this.validator.message(
            "lastName",
            this.props.state.boatUSLastName,
            "required"
          )}
        </div>
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="membershipId">BoatUS Membership ID</label>
            <input
              className="form-control"
              id="membershipId"
              value={this.props.state.boatUSMemberID}
              onChange={this.setID}
            />
            {this.validator.message(
              "memberID",
              this.props.state.boatUSMemberID,
              "required|number"
            )}
          </div>
          <div className="form-group">
            <label htmlFor="zipCode">Zip Code</label>
            <input
              className="form-control"
              id="zipCode"
              value={this.props.state.boatUSZipCode}
              onChange={this.setZip}
            />
            {this.validator.message(
              "zipCode",
              this.props.state.boatUSZipCode,
              "required|number"
            )}
          </div>
        </div>
        {this.validator.customMessage(this.state.boatUSError, "boatus-error")}
        <NextButton
          id="boatUSContinueButton"
          btnClass="btn-primary"
          processing={this.state.processing}
          click={this.callNext}
          icon=""
          text="Add Membership"
          processingText="Verifying..."
        />
      </div>
    )
  }
}

BoatUS.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.shape({
    boatUSLastName: PropTypes.string,
    boatUSMemberID: PropTypes.string,
    boatUSZipCode: PropTypes.string,
  }).isRequired,
}

export default BoatUS
